import { render } from "./WelcomePublicSpeakerComponent.vue?vue&type=template&id=ca7df62c"
import script from "./WelcomePublicSpeakerComponent.vue?vue&type=script&lang=js"
export * from "./WelcomePublicSpeakerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__